import { FormBox } from "@foodpilot/foods";
import { Box } from "@mui/material";
import { ProductFormProductPackaging } from "../../../ProductForm.types";
import { PackagingBox } from "./PackagingBox";
import { Header } from "./Header";

type DisplayPackagingsProps = {
    packagings: ProductFormProductPackaging[];
    setProductPackagings: (newPackagings: ProductFormProductPackaging[]) => void;
    productWeight: number;
    openModal: () => void;
};
export const PackagingsFormGrid = (props: DisplayPackagingsProps) => {
    return (
        <Box style={{ display: "flex", gap: "2rem" }}>
            <FormBox sx={{ flex: 3 }}>
                <Header openModal={props.openModal} />
                <PackagingBox packagings={props.packagings} setProductPackagings={props.setProductPackagings} />
            </FormBox>
        </Box>
    );
};
